export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-background-50 rounded-3xl p-8 md:p-12">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">移动观影</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              窝窝影院移动端适配完美，无论你在地铁通勤、午休间隙还是睡前时光，随时随地打开手机就能畅享高清追剧体验。支持投屏到电视，大屏追剧更过瘾。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm cursor-pointer">
                <i className="ri-android-line"></i>
                Android 下载
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm cursor-pointer">
                <i className="ri-apple-line"></i>
                iOS 下载
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-1.5 px-5 py-2.5 border border-foreground-200 text-foreground-700 rounded-full text-sm cursor-pointer">
                <i className="ri-computer-line"></i>
                网页版体验
              </span>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="w-[240px] h-[480px] md:w-[280px] md:h-[560px] rounded-[2rem] overflow-hidden border-4 border-foreground-200 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20video%20streaming%20app%20interface%20with%20drama%20series%20thumbnails%20and%20play%20button%2C%20dark%20themed%20UI%20design%2C%20movie%20posters%20grid%20layout%2C%20clean%20modern%20mobile%20app%20design%2C%20professional%20app%20screenshot%2C%20minimal%20design&width=560&height=1120&seq=app-mockup-2026&orientation=portrait"
                alt="窝窝影院手机端界面"
                title="窝窝影院移动端 - 随时随地追剧"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}